import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { USER_UPDATE } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

export const api_update_leader = (data) => {
    return (dispatch, getState) => {

        return axios.put(`${Config.API_BASE_URL}/PartnerUser`, data)
        .then(response => {
            dispatch({
                type: USER_UPDATE,
                payload: {
                    ...response.data,
                    task: { result: true }
                }
            })
        })
        .catch(error => {

            dispatch({
                type: USER_UPDATE,
                payload: {
                    errors: error.response.data,
                    task: { result: false }
                }
            })
        });
    };
}


export default api_update_leader;
